import { IContact, IPhoneNumberForEdit } from '@nkr/models/index';

export interface IContactForEdit extends IContact {
    currentPositions: number[],
    phoneNumbersForEdit: IPhoneNumberForEdit[]
}